<template>
    <DropDown 
        starterText="Download Audacity Labels"
        :items="labelTypes"
        :disabled="sound.detections.length === 0"
        :switchToSelected="false"
        customIconClass="fa-solid fa-tag"
        @selected="downloadLabels"
    />
</template>

<script>
import DropDown from '@/widgets/DropDown.vue'
import { JSONtoTSV, addColumns, removeFileExtension, saveTextFileLocally } from '@/js/general.js'
export default {
    name: 'DownloadLabelsDropdown',
    props: ['sound'],
    components: { DropDown },
    data() {
        return {
            labelTypes: [
                {value: 'specie', label: "Latin Name"},
                {value: 'common_name', label: "Common Name (US)"},
            ]
        }
    },
    methods: {
        downloadLabels(selectedColumn){
            // log the event info
            console.log(
                "downloadTSVFileEvent",
                this.sound.requesting_user,
                this.sound.id,
            )
            // validate that there are detections
            if (this.sound.detections.length > 0) {
                // prep the file name
                const textFileName = `${removeFileExtension(this.sound.fileName)}_audacity_${selectedColumn}`
                // add the sound file name column to the detections data
                const detections = addColumns(this.sound.detections, {'file_name': this.sound.fileName})        
                // convert the file from json to tsv
                const file = JSONtoTSV(detections, ['start', 'end', selectedColumn])
                // download the file
                saveTextFileLocally(file, textFileName, 'txt', 'text/tab-separated-values')
            } else {
                console.log('No detections available')
            }
        },
    }
}
</script>

